module.exports = __webpack_public_path__ + "static/logo-6fd5e0bf4c6d1a8299f79d8efcbd1fac.png";